module.exports = __webpack_public_path__ + "img/3.ccb33219.png";